export const delay = (n = 0) => {
  return new Promise((resolve) => setTimeout(resolve, n))
}